module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient top-panel"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "test"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('press.pageHeader')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('press.pageSubheader')) + "\n            ")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('press.mediaTitle')))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('press.mediaTextFirst')) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('press.mediaTextSecond')) + " "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('press.mediaTextLink')))]), _vm._v(" " + _vm._s(_vm.$t('press.mediaTextThird')) + "\n                    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('press.pressResponsibleTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "press-responsible"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/people/nicolai.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inside-box"
  }, [_c('h6', [_vm._v("Nicolai Ramsby")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone fa-fw"
  }), _vm._v(" 31 45 88 37"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-envelope fa-fw"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:nr@deveo.dk"
    }
  }, [_vm._v(_vm._s(_vm.$t('press.pressResponsibleLink')))])])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Logo")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/logo/grey_right.svg"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.png",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" PNG\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.ai",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" AI\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "/static/images/logo/Deveo_logo.svg",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download fa-fw"
  }), _vm._v(" SVG\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30694ff4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/press/pages/index.vue
// module id = 306
// module chunks = 1